import React from 'react';
import { connect } from 'react-redux';

import Node from './Node';
import Loader from './Loader';
import ComponentWrapper from './ComponentWrapper';

import { withStyles } from '@mui/styles';
import { Popper } from '@mui/material';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

class Search extends ComponentWrapper {
  state = {
    nodesData: {},
    searchData: {},
    searchValue: '',
    isDataLoaded: true,
    mouseOverList: false,
    selectedElement: null,
    searchResultsDropdown: [],
    disableFormSubmitHandler: false,
    debounceTimeout: null,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { mouseOverList, searchResultsDropdown } = this.state;

    if (
      searchResultsDropdown.length &&
      !mouseOverList &&
      this.frmContainer &&
      !this.frmContainer.contains(event.target)
    ) {
      this.setState({
        searchData: {},
        selectedElement: null,
        searchResultsDropdown: [],
        disableFormSubmitHandler: false,
      });
    }
  };

  onInputFocus = () => {
    this.onSearchSubmit(true);
  };

  onInputChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onSearchSubmit = (immediate) => {
    let { debounceTimeout } = this.state;
    const { conceptsOnly } = this.props;

    if (debounceTimeout) clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {

      const { ancestorId, rst, nodeId, setup, predefinedResults, filters = [] } = this.props;
      const { searchValue, searchValuePrev, searchResultsDropdown, disableFormSubmitHandler } = this.state;

      if (searchValue === searchValuePrev && searchResultsDropdown.length) return;

      if (disableFormSubmitHandler) {

        this.setState({ disableFormSubmitHandler: false });

      } else {

        this.setState({ isDataLoaded: false }, () => {
          const data = predefinedResults
            ? {
              api_key: setup.id,
              nesting: 0,
              filter: {
                nodes: predefinedResults,
              },
            }
            : rst && rst.is_bounds_func
              ? {
                api_key: setup.id,
                nesting: 0,
                filter: {
                  do_predicate_bounds: true,
                  node_id: nodeId,
                  pid: rst.id,
                  search_query: searchValue,
                },
              }
              : {
                api_key: setup.id,
                nesting: 0,
                filter: {
                  limit: 7,
                  ancestor: ancestorId,
                  search_query: searchValue,
                  trpls: filters,
                }
              };

              if (conceptsOnly) data.filter.tbox_only = true;

          this.postWithData({
            url: `/pnkqry3`,
            data,
            cb: (res) => {
              const searchResultsDropdown = [];
              const searchDataObj = {};

              res && res.query && res.query.forEach((nodeId) => {
                const node = res.nodes[nodeId];

                if (!ancestorId && node.box && node.box.a_bottom && node.box.a_bottom.length) {
                  node.concepts = [];

                  node && node.box && node.box.a_bottom && node.box.a_bottom.forEach((conceptId) => {
                    const concept = res.nodes[conceptId];

                    node.concepts.push({
                      id: concept.id,
                      title: concept.title,
                    });

                    return node;
                  });
                }

                searchResultsDropdown.push(node);
                searchDataObj[node.id] = node;
              });

              if (!searchResultsDropdown.length) searchResultsDropdown.push('empty');

              this.setState({
                isDataLoaded: true,
                searchResultsDropdown,
                searchData: searchDataObj,
                nodesData: res.nodes || {},
                searchValuePrev: searchValue,
              });
            },
          });
        });
      }

      this.setState({ debounceTimeout: null });
    }, immediate ? 0 : 700);

    this.setState({ debounceTimeout: debounceTimeout });
  };

  onNodeClick = (node) => {
    const { searchData, nodesData } = this.state;
    const { onDropdownElementClick, onDropdownElementClickProps, setLoadingTids } = this.props;

    if (onDropdownElementClick) {
      onDropdownElementClick({
        node,
        props: onDropdownElementClickProps || {},
        searchData,
        cb: setLoadingTids,
        nodesData,
      });
    } else {
      document.location.href = `/node/${node.id}`;
    }

    this.setState({
      searchData: {},
      searchValue: '',
      searchResultsDropdown: [],
    });
  };

  onSearchKeyDown = (e) => {
    const { key } = e;
    const { onInputBlur } = this.props;

    let { selectedElement, searchResultsDropdown } = this.state;

    if (key === 'Escape') {
      if (onInputBlur) onInputBlur();

      this.setState({
        selectedElement: null,
        searchResultsDropdown: [],
      });
    }

    if (key === 'ArrowDown') {
      if (selectedElement === searchResultsDropdown.length - 1) return;
      if (selectedElement === null) {
        selectedElement = 0;
      } else {
        selectedElement += 1;
      }

      this.setState({ selectedElement });
    }

    if (key === 'ArrowUp') {
      if (selectedElement === 0) selectedElement = null;
      if (selectedElement !== null) selectedElement -= 1;

      this.setState({ selectedElement });
    }

    if (key === 'Enter' && selectedElement !== null) {
      this.setState({ disableFormSubmitHandler: true }, () => {
        this.onNodeClick(searchResultsDropdown[selectedElement]);
      });

      if (onInputBlur) onInputBlur();
    }
  };

  render() {
    const {
      label,
      account,
      classes,
      nodeSize,
      className,
      fullWidth,
      placeholder,
      inputStyles,
      inputRefFunc,
      showConcepts,
      containerStyles,
      disableTrplEditing,
      onDropdownElementClick,
    } = this.props;

    const { searchValue, isDataLoaded, selectedElement, searchResultsDropdown, searchDropdownListVector } = this.state;

    const containerWidth = this.frmContainer
      ? this.frmContainer.getBoundingClientRect().width
      : containerStyles && containerStyles.width
      ? containerStyles.width
      : '222px';

    return (
      <div
        ref={(frmContainer) => (this.frmContainer = frmContainer)}
        className={`${classes.search} ${className ? className : ''}`}
        style={{
          marginTop: label ? '20px' : '0',
          width: `${fullWidth ? '100%' : '222px'}`,
          ...containerStyles,
        }}
      >
        {label ? <div className={classes.label}>{label}</div> : null}

        <input
          disabled={disableTrplEditing}
          ref={inputRefFunc}
          value={searchValue}
          style={inputStyles}
          placeholder={placeholder}
          className={classes.searchInput}
          onFocus={(e) => {
            if (this.props.onInputFocus) this.props.onInputFocus();

            const { disableInputFocus } = this.props;

            if (!disableInputFocus) this.onInputFocus(e);
          }}
          onBlur={() => {
            if (this.props.onInputBlur) this.props.onInputBlur();

            let { debounceTimeout } = this.state;
            if (debounceTimeout) clearTimeout(debounceTimeout);
          }}
          onChange={(e) => {
            this.setState({ selectedElement: null });
            this.onInputChange('searchValue', e.target.value);
          }}
          onKeyDown={(e) => {
            this.onSearchKeyDown(e);
            this.onSearchSubmit(e.key === 'Enter');
          }}
        />

        {!isDataLoaded ? (
          <Loader style={{ background: 'transparent', margin: '5px 0' }} />
        ) : (
          <SearchOutlinedIcon
            onClick={() => {
              if (!disableTrplEditing) this.onSearchSubmit(true);
            }}
            className={`${classes.searchIcon}`}
            style={{ backgroundColor: containerStyles && containerStyles.backgroundColor || '' }}
          />
        )}

        <Popper anchorEl={this.frmContainer} id={`search-results-popover`} open={Boolean(searchResultsDropdown.length)}>
          <div
            onMouseOver={() => {
              this.setState({ mouseOverList: true, selectedElement: null });
            }}
            onMouseLeave={() => {
              this.setState({ mouseOverList: false });
            }}
            className={`${classes.searchDropdownList}`}
            style={{
              width: containerWidth,
              boxShadow: `${
                searchDropdownListVector === 'top' ? '0px 0px 5px rgba(0, 0, 0, 0.2)' : '0px 5px 5px rgba(0, 0, 0, 0.2)'
              }`,
            }}
          >
            {searchResultsDropdown.map((node, index) => {
              if (node === 'empty') {
                return (
                  <div key={index} className={classes.nothingToShow}>
                    Nothing to show
                  </div>
                );
              }

              return (
                <div key={index} onMouseUp={(e) => {
                  if ((account && account.access_level > 1) && (e.button === 1)) {
                    window.open(`/node/${node.id}`, '_blank', 'noreferrer noopener');
                  } else if (e.button === 0) {
                    this.onNodeClick(node);
                  }
                }}>
                  <Node
                    key={index}
                    node={node}
                    nodeId={node.id}
                    size={nodeSize || 'md'}
                    showConcepts={showConcepts}
                    titleStyle={{
                      maxWidth: 'none',
                    }}
                    className={`${index === selectedElement ? classes.searchItemSelected : ''} ${classes.searchItem}`}
                    isLink={!onDropdownElementClick}
                  />
                </div>
              );
            })}
          </div>
        </Popper>
      </div>
    );
  }
}

const styles = {
  label: {
    top: '-18px',
    fontSize: '0.8em',
    position: 'absolute',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    width: '220px',
    height: '40px',
    backgroundColor: '#e8ebf5',
    marginBottom: '0',
    alignSelf: 'stretch',
    position: 'relative',
    cursor: 'text',
    '&:hover': {
      backgroundColor: 'rgba(157, 175, 228, 0.45)!important',
    },
  },
  searchInput: {
    width: '100%',
    fontSize: '18px',
    fontWeight: '300',
    backgroundColor: 'transparent',
    border: 'none',
    alignSelf: 'stretch',
    paddingLeft: '5px',
  },
  searchIcon: {
    flexShrink: '0',
    color: '#C4C4C4',
    fontSize: '24px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  nothingToShow: {
    display: 'block',
    fontSize: '15px',
    paddingTop: '8px',
    background: '#fff',
    overflow: 'hidden',
    paddingLeft: '10px',
    paddingBottom: '8px',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
  },
  searchItemSelected: {
    background: '#E0E0E0',
  },
  searchDropdownList: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    background: '#fff',
    flexDirection: 'column',
  },
  searchItem: {
    width: '100%',
    '&:hover': {
      backgroundColor: '#E0E0E0',
    },
  },
};

export default connect((state) => ({ setup: state.meta.setup, account: state.meta.account }), {})(withStyles(styles)(Search));
